import {favorite_action} from "../actions/favorite";


const inited = {
    id: null,
    selected: null,
    callback: null,
};

export default function favoriteReducer(state = inited, action) {
    switch (action.type) {
        case favorite_action:
            return {
                ...state,
                ...(action.hasOwnProperty('payload') ? action.payload : inited)
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/libs/redux/reducres/favorite.js